/* Ghost ad landers: swap the hero copy and photo to match the ad that sent the visitor.
   The ad name arrives as utm_content (older links use ?h=). Variants live in the
   JSON written by sections/ghost-lander-kit.liquid. Unknown or missing names keep
   the page's own hero. Also fills the hero photo description when Files has none. */
(function () {
  var kit = document.querySelector('.gl-kit');
  var hero = document.querySelector('[id$="__ghost_hero"]');
  if (!kit || !hero) return;

  var heroImg = hero.querySelector('.chero__media img');
  if (heroImg && !heroImg.alt) heroImg.alt = kit.getAttribute('data-photo-alt') || '';

  var data = document.getElementById('gl-hero-variants');
  if (!data) return;
  try {
    data = JSON.parse(data.textContent);
  } catch (e) {
    return;
  }

  var params = new URLSearchParams(location.search);
  var key = (params.get('utm_content') || params.get('h') || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/_apollo$/, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  if (!key) return;

  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z"></path></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"></circle><path d="M8 12l3 3 5-6"></path></svg>';
  function expand(html) {
    return html
      .split('{stars}').join('<span class="creviews__stars" role="img" aria-label="Rated 5 out of 5 stars">' + STAR + STAR + STAR + STAR + STAR + '</span>')
      .split('{check}').join(CHECK)
      .split('{wordmark}').join(kit.getAttribute('data-wordmark'));
  }

  var text = data.text && data.text[key];
  if (text) {
    var heading = hero.querySelector('.chero__heading');
    var sub = hero.querySelector('.chero__text');
    if (heading) {
      heading.innerHTML = expand(text.h1);
      if (text.fs && innerWidth > 760) heading.style.fontSize = text.fs;
    }
    if (sub) sub.innerHTML = text.sub ? '<p>' + expand(text.sub) + '</p>' : '';
    kit.setAttribute('data-hero', 'swapped');
  }

  var photo = data.photos && data.photos[key];
  if (photo) {
    if (heroImg) {
      heroImg.removeAttribute('srcset');
      heroImg.src = photo.src;
      heroImg.alt = photo.alt;
      heroImg.style.objectPosition = photo.pos;
    }
  }
})();

/* Headlines: one sentence per line, the way the approved pages set them. Each sentence
   becomes a line, and the font size steps down until the longest line fits the column
   (never below a readable minimum, where a line wraps instead). Check-list items with
   two sentences stack them the same way. Runs after the hero swap above. */
(function () {
  if (!document.querySelector('.gl-kit')) return;
  var HEADINGS = '[id$="__ghost_hero"] .chero__heading, .creviews__heading, .product-cards__title, .vchart__heading, .vchart__tagline, .fpress__heading, .pfaq__heading, .close-panel__heading';
  // A non-breaking space after a full stop keeps two short sentences on one line.
  var SENTENCE_END = /((?<!\.\.)[.?!][”’"]?)[ \t\n]+(?=[“‘"A-Z0-9]|\.\.\.)/g;

  function split(el) {
    if (el.querySelector(':scope > .gl-ln')) return;
    el.classList.add('gl-head');
    var html = el.innerHTML.replace(/\s*<br\s*\/?>\s*/g, ' ');
    el.innerHTML = html.replace(SENTENCE_END, '$1\u0000').split('\u0000').map(function (part) {
      // No hanging words: the last two words of a sentence never split across lines.
      var glued = part.trim().replace(/ ([^ <>]+)$/, '\u00a0$1');
      return '<span class="gl-ln gl-one">' + glued + '</span>';
    }).join(' ');
  }

  function width(node) {
    var range = document.createRange();
    range.selectNodeContents(node);
    return range.getBoundingClientRect().width;
  }

  function fit(el) {
    split(el);
    if (el.dataset.fs0 === undefined) el.dataset.fs0 = el.style.fontSize || '';
    el.classList.remove('gl-fitted');
    el.style.fontSize = el.dataset.fs0;
    var lines = [].slice.call(el.querySelectorAll('.gl-ln'));
    lines.forEach(function (l) { l.classList.add('gl-one'); });
    var cs = getComputedStyle(el);
    var avail = el.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    el.style.overflow = 'hidden';
    el.style.maxWidth = avail + 'px';
    el.classList.add('gl-fitted');
    var base = parseFloat(cs.fontSize);
    var need = 0;
    lines.forEach(function (l) { need = Math.max(need, width(l)); });
    el.style.maxWidth = '';
    if (!avail || !need) {
      el.classList.remove('gl-fitted');
      el.style.overflow = '';
      return;
    }
    var vw = document.documentElement.clientWidth;
    var hero = el.classList.contains('chero__heading');
    var min = vw >= 700 ? 28 : Math.max(18, Math.round(vw / 19.5));
    var size = need > avail ? Math.floor(base * avail / need * 0.98) : base;
    if (hero && vw < 700) {
      // Phones: one line per sentence at the largest size that fits (up to the 40px phone
      // size) when that is 25px or more. Otherwise two full-width lines at up to 30px, and
      // three or more lines at 30px only when two lines would need less than 26px.
      if (size < 25) {
        var two = Math.floor(base * 2 * avail / need * 0.9);
        size = two >= 26 ? Math.min(30, two) : 30;
      }
    } else if (size < min) {
      size = min;
    }
    el.style.fontSize = size + 'px';
    lines.forEach(function (l) { if (width(l) > avail + 1) l.classList.remove('gl-one'); });
    el.style.overflow = '';
  }

  function stack(el) {
    if (!el.querySelector('.gl-s')) {
      var parts = el.innerHTML.replace(SENTENCE_END, '$1\u0000').split('\u0000');
      if (parts.length < 2) return;
      el.innerHTML = parts.map(function (p) { return '<span class="gl-s">' + p.trim() + '</span>'; }).join(' ');
    }
    el.classList.remove('gl-stack');
    var lh = parseFloat(getComputedStyle(el).lineHeight) || 20;
    if (el.getBoundingClientRect().height > lh * 1.5) el.classList.add('gl-stack');
  }

  function all() {
    document.querySelectorAll(HEADINGS).forEach(fit);
    document.querySelectorAll('[id$="__ghost_hero"] .chero__list li > span').forEach(stack);
  }

  all();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(all);
  addEventListener('load', all);
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) fit(e.target); });
    }, { rootMargin: '400px 0px' });
    document.querySelectorAll(HEADINGS).forEach(function (el) { io.observe(el); });
  }
  var timer;
  var lastWidth = innerWidth;
  addEventListener('resize', function () {
    if (innerWidth === lastWidth) return;
    lastWidth = innerWidth;
    clearTimeout(timer);
    timer = setTimeout(all, 120);
  });
})();

/* Site chrome on ad landers: the header button starts the trial instead of the hearing
   screener, and the announcement bar carries the trial promise. */
(function () {
  if (!document.querySelector('.gl-kit')) return;
  document.querySelectorAll('a[href="/pages/screener"]').forEach(function (a) {
    a.href = '/collections/frontpage';
    var walker = document.createTreeWalker(a, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      var node = walker.currentNode;
      if (/Free Hearing Test/.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace('Free Hearing Test', 'Start my 45-day trial');
    }
    a.querySelectorAll('[data-text]').forEach(function (el) {
      el.setAttribute('data-text', el.getAttribute('data-text').replace('Free Hearing Test', 'Start my 45-day trial'));
    });
  });
  var lines = ['45 days. Love them or your money back.', 'Free express shipping. Free returns.', 'No hearing test. No appointment.'];
  var slides = document.querySelectorAll('.announcement__slide');
  if (slides.length) {
    var parent = slides[0].parentNode;
    while (parent.querySelectorAll('.announcement__slide').length < lines.length) {
      var copy = slides[0].cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      parent.appendChild(copy);
    }
    parent.querySelectorAll('.announcement__slide').forEach(function (slide, i) {
      var p = slide.querySelector('.announcement-text');
      if (p && lines[i]) p.textContent = lines[i];
      else if (!lines[i]) slide.remove();
    });
  }
})();
